<template>
  <div class="ec-line004">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: isCartPeriodic ? $routePage.EC_LINE029_001 : $routePage.EC_LINE029_002 }">{{
        $t('ec-line029.title')
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>
        {{ isCartPeriodic ? $t('ec-line003.tab.subscription') : $t('ec-line003.tab.normal') }}</el-breadcrumb-item
      >
    </el-breadcrumb>
    <the-heading class="lg:mb-8 mb-5">
      {{ isCartPeriodic ? $t('ec-line003.tab.subscription') : $t('ec-line003.tab.normal') }}
      <br />
      {{ $t('ec-line004.heading') }}
    </the-heading>
    <purchase-detail-card
      :data="form.carts"
      :summary="isCartPeriodic ? subscriptionCartsSummary : normalCartsSummary"
      :isCartPeriodic="isCartPeriodic"
    ></purchase-detail-card>
    <purchase-information-card
      :data="form.purchase"
      :businessAccountFlag="form.purchase.businessAccountFlag"
    ></purchase-information-card>
    <shipping-information-card
      :isCartPeriodic="isCartPeriodic"
      :data="form.shipping"
      :business-account-flag="form.purchase.business_account_flag"
      :is-not-bundled-remote-island="isNotBundledRemoteIsland"
    ></shipping-information-card>
    <subscription-information-card v-if="isCartPeriodic" :data="form.subscription"></subscription-information-card>
    <payment-information-card :data="form.payment"></payment-information-card>
    <other-information-card :data="form.others"></other-information-card>
    <iframe ref="iFrame" :src="defrayalECLine004" class="mt-3 w-full bg-gray" scrolling="no"></iframe>
    <div class="flex flex-col items-center lg:flex-row justify-center mt-5 lg:mt-10 lg:mb-4">
      <el-button class="submit-btn lg:ml-6 lg:order-1" @click="onSubmit">{{
        $t('ec-line004.confirmOrderBtn')
      }}</el-button>
      <el-button class="cancel-btn mt-5 mb-1 lg:my-0" @click="onEdit">{{
        user ? $t('ec-line004.editCartBtn') : $t('ec-line004.editPurchaseBtn')
      }}</el-button>
    </div>
    <order-wait-dialog :visible.sync="isOrderWaitVisible" :content="$t('ec-line004.confirmSkipAmapayOrderMsg')" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import mixinAmazon from '@/mixins/amazonV2'
import liff from '@line/liff'
import PurchaseDetailCard from '@/components/ec-line004/PurchaseDetailCard.vue'
import PurchaseInformationCard from '@/components/ec-line004/PurchaseInformationCard.vue'
import ShippingInformationCard from '@/components/ec-line004/ShippingInformationCard.vue'
import SubscriptionInformationCard from '@/components/ec-line004/SubscriptionInformationCard.vue'
import PaymentInformationCard from '@/components/ec-line004/PaymentInformationCard.vue'
import OtherInformationCard from '@/components/ec-line004/OtherInformationCard.vue'
import { AMAZON } from '@/constants/amazon'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import mixinRegisterCustomer from '@/mixins/register-customer'
import { OrderService } from '@/services'
import mixinGMO from '@/mixins/gmo'
import { ENV_KEY } from '@/constants/env'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import deliveryNoteMixin from '@/mixins/deliveryNote'
import { MAIL_DELIVERY_SERVICE } from '@/constants'
import { getAuth } from '@/router/func'
import { AuthService } from '@/services'
import OrderWaitDialog from '@/components/OrderWaitDialog.vue'

export default {
  name: 'EC-LINE004',
  mixins: [mixinRegisterCustomer, mixinGMO, mixinAmazon, BreadcrumbMixin, deliveryNoteMixin],
  components: {
    PurchaseDetailCard,
    PurchaseInformationCard,
    ShippingInformationCard,
    SubscriptionInformationCard,
    PaymentInformationCard,
    OtherInformationCard,
    TheHeading,
    OrderWaitDialog,
  },
  data() {
    return {
      form: {
        carts: [],
        purchase: {
          name01: '',
          name02: '',
          kana01: '',
          kana02: '',
          year: null,
          month: null,
          day: null,
          gender: null,
          email: '',
          email_confirm: '',
          phone_number: '',
          postal_code01: '',
          postal_code02: '',
          prefecture: null,
          addr01: '',
          addr02: '',
          addr03: '',
        },
        shipping: {
          name01: '',
          name02: '',
          kana01: '',
          kana02: '',
          postal_code01: '',
          postal_code02: '',
          prefecture: null,
          addr01: '',
          addr02: '',
          addr03: '',
          phone_number: '',
          shipping_method: null,
          shipping_address: null,
          delivery_date: null,
          delivery_time: null,
          delivery_division_id: null,
          cooling_off_flag: false,
          time_note_disable_flag: false,
        },
        subscription: {
          delivery_pattern: '',
          delivery_interval: null,
          next_delivery_date_often: Date.now(),
          next_delivery_date: Date.now(),
        },
        payment: {
          card_type: '',
          card_number: '',
          payment_method: null,
          amazon_card: null,
        },
        others: {
          where_find_product: '',
          advertisement_remarks: '',
        },
      },
      hasErrorOrder: false,
      isPocessAmazonRedirect: false,
      isOrderWaitVisible: false,
    }
  },
  computed: {
    isCartPeriodic() {
      return this.$route.path.includes(this.Constants.CART_TYPE.PERIODIC)
    },
    desiredDeliveryDays() {
      return this.$store.getters['master/desiredDeliveryDays']()
    },
    data() {
      return this.$store.state.register.customer
    },
    user() {
      return this.$store.state.auth.user
    },
    normalCartsSummary() {
      return this.$store.state.cart.normalCartsSummary
    },
    subscriptionCartsSummary() {
      const subscriptionCartsSummary = cloneDeep(this.$store.state.cart.subscriptionCartsSummary)
      let delivery_fee = 0
      if (subscriptionCartsSummary.is_shipping_free === false) {
        delivery_fee = Number(subscriptionCartsSummary.delivery_fee)
      }
      const subtotal = Number(subscriptionCartsSummary.subtotal)
      const next_subtotal = Number(subscriptionCartsSummary.next_subtotal)
      subscriptionCartsSummary.delivery_fee = delivery_fee
      subscriptionCartsSummary.next_delivery_fee = delivery_fee
      subscriptionCartsSummary.six_month_delivery_fee = delivery_fee * 6
      subscriptionCartsSummary.six_month_payment_total = subtotal + next_subtotal * 5
      subscriptionCartsSummary.six_month_payment_total += delivery_fee * 6
      subscriptionCartsSummary.is_lump_sum_payment = this.$store.state.cart.carts.some(
        (item) => item.lump_sum_payment_flag
      )
      return subscriptionCartsSummary
    },
    amountChangeFlag() {
      return this.$store.state.cart.amountChangeFlag
    },
    isNotBundledRemoteIsland() {
      return this.$store.state.cart.isNotBundledRemoteIsland
    },
    paymentMethod() {
      return this.$store.state.register.paymentMethods?.find(
        (method) => method.id === this.data.paymentInformation.methodOfPayment
      )
    },
    saleType() {
      return this.isCartPeriodic ? this.Constants.CART_TYPES.SUBSCRIPTION : this.Constants.CART_TYPES.NORMAL
    },
    defrayalECLine004() {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${this.Constants.SHOP_CONFIG.DEFRAYAL_EC_LINE004}`
    },
    isConfirmSkip() {
      return this.$store.getters['auth/shop']?.confirm_skip_ec_site_flag
    },
    getPayloadCartTrackingData() {
      return this.$store.getters['cartTracking/cartTrackingData'] || {}
    },
    cartAbandonmentFlags() {
      return this.$store.getters['cartTracking/cartAbandonmentFlags']
    },
    isCartAbandonment() {
      const flag = this.cartAbandonmentFlags
      const user = this.user

      if (!flag || !flag.ec_flag) return false

      const isCustomerTarget = flag.customer_target_flag && !!user
      const isGuestTarget = flag.guest_target_flag && !user

      return isCustomerTarget || isGuestTarget
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  async created() {
    if (this.isConfirmSkip) {
      this.isOrderWaitVisible = true
    }
    this.initOrder()
    this.initMemberInfo()
    await Promise.all([
      this.fetchPaymentMethods({ delivery_id: this.data.shippingInformation.delivery_id }),
      this.fetchShippingMethod(),
      this.fetchDeliveryTimezone(this.data.shippingInformation.delivery_id),
    ])
    this.initShippingInfo()
    this.initSubscription()
    this.initPaymentInfo()
    this.initOtherInfo()
    if (this.isLoginAmazon) {
      this.processAmazonRedirect()
    }
    if (this.amountChangeFlag) {
      this.handleError({ message: this.$t('common.messages.isPurchaseAmountChange') })
    }
    this.skipToAutoOrder()
  },
  mounted() {
    this.resizeIFrameToFitContent()
  },
  methods: {
    /**
     * Init list cart
     */
    initOrder() {
      this.hasErrorOrder = this.$store.state.cart.carts.some(
        (item) =>
          this.saleType === Number(item.subscription) &&
          ([item.is_product_sku_valid, item.visible].includes(false) || item.is_out_stock === true)
      )
      this.hasErrorOrder && this.handleError({ message: this.$t('common.error.orderError') })
      const carts = this.$store.state.cart.carts?.filter(
        (item) =>
          this.saleType === Number(item.subscription) &&
          ![item.is_product_sku_valid, item.visible].includes(false) &&
          item.is_out_stock === false
      )

      if (!carts?.length) return

      this.form.carts = carts.map((cart) => ({
        id: cart.id,
        name: cart.product_name,
        img: cart.product_image,
        price: cart.subscription ? cart.price03_after_tax : cart.price02_after_tax,
        subtotal: cart.subscription ? cart.product_subtotal_price03_after_tax : cart.product_subtotal_price02_after_tax,
        quantity: cart.quantity,
        colorName: cart.sku_item_parent_name_1,
        sizeName: cart.sku_item_parent_name_2,
        color: cart.sku_set_item_name1,
        size: cart.sku_set_item_name2,
        discountAmount: cart.product_subtotal_discount_amount,
        is_product_sku_valid: cart.is_product_sku_valid,
        product_id: cart.product_id,
        is_out_stock: cart.is_out_stock,
        sale_limit: cart.sale_limit,
        visible: cart.visible,
        nextPrice: cart.subscription ? cart.next_price03_after_tax : null,
        nextSubtotal: cart.subscription ? cart.next_subtotal_price03_after_tax : null,
        nextDiscountAmount: cart.next_subtotal_discount_amount,
      }))
    },
    /**
     * Init member information
     */
    initMemberInfo() {
      const { memberInformation } = this.data
      this.form.purchase = {
        name01: memberInformation.lastName,
        name02: memberInformation.firstName,
        kana01: memberInformation.lastNameKana,
        kana02: memberInformation.firstNameKana,
        year: memberInformation.birthdayYear,
        month: memberInformation.birthdayMonth,
        day: memberInformation.birthdayDay,
        gender: this.$store.state.master.sex?.find((item) => item.id === memberInformation.sex)?.name,
        email: memberInformation.email,
        email_confirm: memberInformation.emailConfirm,
        phone_number: memberInformation.phoneNumber,
        postal_code01: memberInformation.postalCode1,
        postal_code02: memberInformation.postalCode2,
        prefecture: this.$store.state.master.pref?.find((item) => item.id === memberInformation.prefecture)?.name,
        addr01: memberInformation.municipality,
        addr02: memberInformation.address,
        addr03: memberInformation.buildingApartmentName,
        company_name: this.corporateFlag ? memberInformation.companyName : null,
        business_account_flag: memberInformation.businessAccountFlag,
      }
    },

    /**
     * Init shipping information
     */
    initShippingInfo() {
      const { shippingInformation } = this.data

      let delivery_time_text = ''
      if (shippingInformation.desiredDeliveryTimeZone) {
        delivery_time_text = shippingInformation.deliveryTimes?.find(
          (item) => item.value === shippingInformation.desiredDeliveryTimeZone
        )?.label
      } else {
        delivery_time_text = shippingInformation.isAvailableDeliveryTime
          ? this.$t('common.placeholder.unspecified')
          : this.$t('common.placeholder.unavailableTimeZone')
      }

      this.form.shipping = {
        name01: shippingInformation.lastName,
        name02: shippingInformation.firstName,
        kana01: shippingInformation.lastNameKana,
        kana02: shippingInformation.firstNameKana,
        postal_code01: shippingInformation.postalCode1,
        postal_code02: shippingInformation.postalCode2,
        prefecture: this.$store.state.master.pref?.find((item) => item.id === shippingInformation.prefecture)?.name,
        addr01: shippingInformation.municipality,
        addr02: shippingInformation.address,
        addr03: shippingInformation.buildingApartmentName,
        phone_number: shippingInformation.phoneNumber,
        shipping_method: shippingInformation.shippingMethod,
        shipping_method_text: this.$store.state.register.shippingMethods?.find(
          (item) => item.delivery_division_id === shippingInformation.shippingMethod
        )?.delivery_division_name,
        shipping_address: this.deliveryDestinations?.find(
          (item) => item.value === shippingInformation.deliveryDestination
        )?.label,
        delivery_destination: shippingInformation.deliveryDestination,
        delivery_date: shippingInformation.desiredDeliveryDay,
        delivery_date_text: this.Utils.date.formatDateJP(shippingInformation.desiredDeliveryDay),
        delivery_time: shippingInformation.desiredDeliveryTimeZone,
        delivery_time_text: delivery_time_text,
        delivery_note_id: shippingInformation.delivery_note_id,
        delivery_note_text:
          this.deliveryNotes.find((item) => item.value === shippingInformation.delivery_note_id)?.label ||
          shippingInformation.delivery_notes,
        bundled_flag: shippingInformation.bundled_flag,
        delivery_division_id: shippingInformation.shippingMethod,
        time_note_disable_flag: shippingInformation.time_note_disable_flag,
      }
    },

    /**
     * Init Subscription information
     */
    async initSubscription() {
      const { subscription, shippingInformation } = this.data

      this.form.subscription = {
        delivery_pattern: this.deliveryPatterns?.find((item) => item.value === subscription.deliveryPattern)?.label,
        delivery_interval: subscription.deliveryInterval,
        next_delivery_date_often: shippingInformation.desiredDeliveryDay,
        next_delivery_date: subscription.secondDeliveryDate,
      }
    },

    /**
     * Init payment information
     */
    initPaymentInfo() {
      const { paymentInformation } = this.data
      this.form.payment = {
        card_number: paymentInformation.cardNumber,
        card_month: paymentInformation.dateOfExpiredMonth,
        card_year: paymentInformation.dateOfExpiredYear,
        payment_method: this.getServiceIdByPaymentId(paymentInformation.methodOfPayment),
        amazon_card: paymentInformation.amazonCard,
        card_holder: paymentInformation.cardHolder,
        number_of_payment: paymentInformation.numberOfPayment,
        security_code: paymentInformation.securityCode,
      }
    },

    /**
     * Init other information
     */
    initOtherInfo() {
      const { placeFindThisProduct, advertisement_remarks } = this.data
      this.form.others = {
        where_find_product: placeFindThisProduct,
        advertisement_remarks: advertisement_remarks,
      }
    },

    /**
     * Init data after redirect authorize amazon
     */
    processAmazonRedirect() {
      if (this.$route.query.amazonCheckoutSessionId && !!this.$session[AMAZON.CART_LINE004]) {
        // this.loading = true
        this.isPocessAmazonRedirect = true

        const form = cloneDeep(JSON.parse(this.$session[AMAZON.CART_LINE004]))

        form.amazon_checkout_session_id = this.$session[AMAZON.ACCESS_TOKEN_029]
        localStorage.removeItem(AMAZON.CART_LINE004)
        this.createOrder(form)
      }
    },

    /**
     * Handle submit button
     */
    async onSubmit() {
      this.isOrderWaitVisible = true
      const payload = await this.initPayloadSubmit()

      // 登録済み会員の場合は更新処理
      // 差分がなければ対応履歴は残らない
      if (payload.customer.customer_id) {
        // 更新後、会員情報を新しく取得
        await AuthService.updateInfo(payload.customer.customer_id, payload.customer)
          .then(() => getAuth())
          .catch((error) => this.handleError(error))
      }

      if (this.isLoginAmazon) {
        this.preOrderByAmazon(payload)
      } else {
        this.createOrder(payload)
      }
    },

    async createOrder(payload) {
      const loading = this.$loading({
        lock: true,
      })
      this.isOrderWaitVisible = true
      try {
        const { data } = await OrderService.order(payload)
        const customer_id = data.order.customer_id
        const order_id = data.order.id
        const subscription_id = data.order.subscription_id ?? ''
        const newCustomer = { customer_id, order_id, subscription_id, ...this.data }

        localStorage.setItem(AMAZON.CART_LINE029, JSON.stringify(newCustomer))

        this.$router.replace({
          path: this.isCartPeriodic ? this.$routePage.EC_LINE005_001 : this.$routePage.EC_LINE005_002,
        })
      } catch (error) {
        this.handleError(error)
      } finally {
        loading.close()
        this.isOrderWaitVisible = false
        if (this.isLoginAmazon) {
          this.onAmazonLogout(AMAZON.ACCESS_TOKEN_029)
        }
      }
    },

    async preOrderByAmazon(payload) {
      try {
        const { data } = await this.updateAmazonPermission(payload.order.payment_total, AMAZON.ACCESS_TOKEN_029)

        if (data?.webCheckoutDetails?.amazonPayRedirectUrl) {
          this.$session[AMAZON.CART_LINE029] = JSON.stringify(this.data)
          this.$session[AMAZON.CART_LINE004] = JSON.stringify(payload)
          window.location.href = data?.webCheckoutDetails?.amazonPayRedirectUrl
        }
      } catch (error) {
        this.handleError(error)
      }
    },

    async initPayloadSubmit() {
      const {
        memberInformation,
        shippingInformation,
        subscription,
        paymentInformation,
        placeFindThisProduct,
        advertisement_remarks,
      } = this.data

      let gmoTokens

      if (
        this.paymentMethod.payment_service_id === this.Constants.PAYMENT_METHOD.CREDIT_CARD &&
        !paymentInformation.cardSeq
      ) {
        gmoTokens = await this.getTokenCard({
          holdername: paymentInformation.cardHolder,
          cardno: paymentInformation.cardNumber,
          expire: `20${paymentInformation.dateOfExpiredYear}${paymentInformation.dateOfExpiredMonth.padStart(2, '0')}`,
          securitycode: paymentInformation.securityCode,
          tokennumber: 2,
        })
      }

      const summary = this.isCartPeriodic ? this.subscriptionCartsSummary : this.normalCartsSummary

      const payload = {
        customer: {
          customer_id: this.user?.id || null,
          name01: memberInformation.lastName || null,
          name02: memberInformation.firstName || '',
          kana01: memberInformation.lastNameKana || null,
          kana02: memberInformation.firstNameKana || '',
          birth:
            memberInformation.birthdayYear && memberInformation.birthdayMonth && memberInformation.birthdayDay
              ? this.Utils.date.getDateString(
                  this.$date.getTime(
                    this.$date.set(new Date(), {
                      year: memberInformation.birthdayYear,
                      month: memberInformation.birthdayMonth - 1,
                      date: memberInformation.birthdayDay,
                    })
                  )
                )
              : null,
          sex_id: memberInformation.sex,
          email: memberInformation.email,
          postal_code: [memberInformation.postalCode1, memberInformation.postalCode2].join(
            this.$t('common.hyphenSeparator')
          ),
          pref_id: memberInformation.prefecture || null,
          addr01: memberInformation.municipality || null,
          addr02: memberInformation.address || null,
          addr03: memberInformation.buildingApartmentName || null,
          phone_number: memberInformation.phoneNumber || null,
          customer_status: this.user?.customer_status_id || null,
          company_name: this.corporateFlag ? memberInformation.companyName || null : null,
          business_account_flag: memberInformation.businessAccountFlag || false,
        },
        order: {
          name01: memberInformation.lastName || null,
          name02: memberInformation.firstName || '',
          kana01: memberInformation.lastNameKana || null,
          kana02: memberInformation.firstNameKana || '',
          birth:
            memberInformation.birthdayYear && memberInformation.birthdayMonth && memberInformation.birthdayDay
              ? this.Utils.date.getDateString(
                  this.$date.getTime(
                    this.$date.set(new Date(), {
                      year: memberInformation.birthdayYear,
                      month: memberInformation.birthdayMonth - 1,
                      date: memberInformation.birthdayDay,
                    })
                  )
                )
              : null,
          sex_id: memberInformation.sex,
          email: memberInformation.email,
          password: memberInformation.password,
          postal_code: [memberInformation.postalCode1, memberInformation.postalCode2].join(
            this.$t('common.hyphenSeparator')
          ),
          pref_id: memberInformation.prefecture || null,
          addr01: memberInformation.municipality || null,
          addr02: memberInformation.address || null,
          addr03: memberInformation.buildingApartmentName || null,
          phone_number: memberInformation.phoneNumber || null,
          where_did_you_know_id: placeFindThisProduct,
          customer_id: this.user?.id || null, // Confirm
          country_id: this.Constants.DEFAULT_COUNTRY_ID, // Fixed 392
          payment_id: this.paymentMethod.id || null, // Payment methods
          device_type_id: this.Utils.helper.deviceType(this.$store.state.auth.shop), //Master
          delivery_fee_total: Number(summary.delivery_fee),
          payment_total: Number(summary.payment_total),
          line_id: this.liffIdExists ? (liff.isLoggedIn() && (await liff.getProfile())?.userId) || null : null,
          credit_card_registration_seq:
            this.paymentMethod.payment_service_id === this.Constants.PAYMENT_METHOD.CREDIT_CARD &&
            paymentInformation.cardSeq
              ? paymentInformation.cardSeq
              : null,
          advertisement_code: localStorage.getItem(this.Constants.ADCD),
          advertisement_remarks: advertisement_remarks,
          ...(this.form.shipping.shipping_method_text !== MAIL_DELIVERY_SERVICE && {
            delivery_note_id: shippingInformation.delivery_note_id,
            delivery_notes: null,
          }),
          bundled_flag: shippingInformation.bundled_flag,
          company_name: this.corporateFlag ? memberInformation.companyName || null : null,
          business_account_flag: memberInformation.businessAccountFlag || false,
          cooling_off_flag: shippingInformation.cooling_off_flag,
        },
        shipping: {
          id: shippingInformation.addressId || null,
          name01: shippingInformation.lastName || null,
          name02: shippingInformation.firstName || '',
          kana01: shippingInformation.lastNameKana || null,
          kana02: shippingInformation.firstNameKana || '',
          postal_code: [shippingInformation.postalCode1, shippingInformation.postalCode2].join(
            this.$t('common.hyphenSeparator')
          ),
          pref_id: shippingInformation.prefecture || null,
          addr01: shippingInformation.municipality || null,
          addr02: shippingInformation.address || null,
          addr03: shippingInformation.buildingApartmentName || null,
          phone_number: shippingInformation.phoneNumber || null,
          time_id: shippingInformation.desiredDeliveryTimeZone || null, // Get time shipping
          delivery_date: this.$date.startOfDay(this.form.subscription.next_delivery_date_often).getTime() || null, // Get first day
          delivery_id: shippingInformation.delivery_id || null,
          country_id: this.Constants.DEFAULT_COUNTRY_ID,
          delivery_division_id: shippingInformation.shippingMethod,
          delivery_service_id: shippingInformation.delivery_service_id,
          time_note_disable_flag: shippingInformation.time_note_disable_flag,
        },
        order_item:
          this.$store.state.cart.carts
            ?.filter((item) => this.saleType === Number(item.subscription) && item.is_product_sku_valid)
            ?.map((item) => ({
              product_sku_id: item.id,
              quantity: item.quantity,
              price: item.subscription ? Number(item.price03_after_tax) : Number(item.price02_after_tax),
              discount_amount: Number(item.discount_amount),
            })) || null,
        subscription: this.isCartPeriodic
          ? {
              customer_id: this.user?.id || null,
              customer_address_id: shippingInformation.addressId || null, // Id in address list
              payment_id: this.paymentMethod.id || null, // Payment methods
              time_id: shippingInformation.desiredDeliveryTimeZone || null, // Get time shipping
              subscription_delivery_pattern: {
                subscription_division_id: subscription.deliveryPattern, // Pattern
                param1: subscription.deliveryInterval, // Interval
                param2: this.$date.getDate(new Date(this.form.subscription.next_delivery_date_often)),
                next_delivery_date: this.Utils.date.getDateString(this.form.subscription.next_delivery_date_often), // First day
                next_next_delivery_date: this.Utils.date.getDateString(subscription.secondDeliveryDate), // Second day
              },
              delivery_division_id: shippingInformation.shippingMethod,
            }
          : null,
        gmo_payment_tokens:
          this.paymentMethod.payment_service_id === this.Constants.PAYMENT_METHOD.CREDIT_CARD &&
          !paymentInformation.cardSeq
            ? gmoTokens
            : null, // 2 token
        ...(!!gmoTokens && {
          card_info: {
            holder_name: this.form.payment.card_holder,
            expire: `${this.form.payment.card_month.padStart(2, '0')}/${this.form.payment.card_year.padStart(2, 0)}`,
          },
        }),
        cart_tracking: this.isCartAbandonment
          ? {
              id: this.getPayloadCartTrackingData.tracking_id,
              cart_type_id: this.getPayloadCartTrackingData.cart_type_id, // 購入画面（LPカート/ショップEC）を判断するID
              tracking_start_date: this.getPayloadCartTrackingData.tracking_start_date,
              customer_id: this.user?.id || null,
              email: memberInformation.email,
              phone_number: memberInformation.phoneNumber || null,
              line_id: this.liffIdExists ? (liff.isLoggedIn() && (await liff.getProfile())?.userId) || null : null,
              order_completed_flag: true,
              url_clicked: this.getPayloadCartTrackingData.url_clicked,
            }
          : undefined,
      }

      return payload
    },

    onEdit() {
      this.$router.push(this.isCartPeriodic ? this.$routePage.EC_LINE029_001 : this.$routePage.EC_LINE029_002)
    },

    resizeIFrameToFitContent() {
      let iframe = this.$refs.iFrame
      iframe.onload = () => {
        iframe.removeAttribute('style')
        iframe.style.height = 'calc(' + iframe.contentWindow.document.body.scrollHeight + 'px + ' + '16px)'
      }
    },
    getServiceIdByPaymentId(id) {
      return this.$store.state.register.paymentMethods.find((item) => item.id === id)?.payment_service_id
    },
    skipToAutoOrder() {
      if (this.isConfirmSkip && !this.isPocessAmazonRedirect) {
        this.onSubmit()
      }
    },
  },
  metaInfo() {
    return {
      title: this.isCartPeriodic ? this.$t('ec-line004.metaSubscriptionTitle') : this.$t('ec-line004.metaNormalTitle'),
      script: [
        {
          src: process.env.VUE_APP_GMO_LIB_URL,
        },
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.isCartPeriodic
            ? this.$t('ec-line004.description', { shop_name: this.shopName })
            : this.$t('ec-line004.normalDescription', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.isCartPeriodic
            ? this.$t('ec-line004.keyword', { shop_name: this.shopName })
            : this.$t('ec-line004.normalKeyword', { shop_name: this.shopName }),
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: this.Constants.META_TAG.NO_INDEX_NO_FOLLOW,
        },
      ],
    }
  },
}
</script>

<style lang="sass">
@import '@/assets/css/pages/ec-line004.scss'
</style>
